import { useState } from 'react';
import TradeCalculator, { TRADES } from '../components/TradeCalculator';

export default function PaintingCalculatorPage() {
  const [trade, setTrade] = useState('painting');
  return (
    <>
      <div className="page-header">
        <h2>Commission Calculator</h2>
        <div style={{ fontSize: 13, color: '#888' }}>Work out the price and your commission — pick a job type</div>
      </div>
      <div className="page-body">
        <div style={{ marginBottom: 18 }}>
          <label style={{ fontSize: 11, color: '#666', textTransform: 'uppercase', letterSpacing: 0.5, marginRight: 8 }}>Job type:</label>
          <select value={trade} onChange={e => setTrade(e.target.value)}
            style={{ padding: '8px 12px', border: '1px solid #ccc', borderRadius: 8, fontSize: 14, fontWeight: 600, color: '#0D3B2E' }}>
            {Object.entries(TRADES).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
          </select>
        </div>
        <TradeCalculator trade={trade} />
      </div>
    </>
  );
}
